export const QUEUE_RULES_RECALCULATION = 'rule:recalculation';
export const QUEUE_SCHEMA_REFRESH = 'rule:schema_refresh';
export const QUEUE_TEMPLATES_APPLY = 'templates:apply';
export const QUEUE_FIX_DEAD_ASSOCIATIONS = 'fix:dead:associations';
export const QUEUE_REFRESH_CLIENT = 'client:refresh';
